// extracted by mini-css-extract-plugin
module.exports = {"aiAssistantPage":"AIAssistantPage_aiAssistantPage__3oet9","aiAssistantPage_advanced":"AIAssistantPage_aiAssistantPage_advanced__3fSYR"};